import appConstants from '../constants';

export default function extractDiversityInfoFromQualifications(partnerQualifications) {
  let diversityObject = {
    isDiversePartner: false,
    partnerDiversityProgramNames: []
  }
  if(!!partnerQualifications && !!partnerQualifications.length) {
    const filteredQualifications = partnerQualifications.filter((partnerQualification) => partnerQualification[appConstants.KEY_CATEGORY_DISPLAY_NAME] === appConstants.VALUE_DIVERSE_PARTNERS);
    if(!!filteredQualifications.length) {
      diversityObject.isDiversePartner = true;
      filteredQualifications.forEach((filteredQualification) => { diversityObject.partnerDiversityProgramNames.push(filteredQualification[appConstants.KEY_KEYWORD_DISPLAY_NAME]); });
    }
  }
  return diversityObject;
}
